// Based on 'mdi-material-ui/RecordCircle'

// eslint-disable-next-line max-len
export const svgPathData = 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7Z';
export const svgPath = `path://${svgPathData}`;
